import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.524 7.933v3.4a.667.667 0 1 0 1.334 0v-3.4a3.333 3.333 0 1 0-1.334 0m.667-5.266a2 2 0 1 1 0 4 2 2 0 0 1 0-4m2.807 6.946a.681.681 0 0 0-.28 1.334c1.513.3 2.14.84 2.14 1.053 0 .387-1.634 1.333-4.667 1.333S3.524 12.387 3.524 12c0-.213.627-.753 2.14-1.08a.681.681 0 0 0-.28-1.333c-2.026.466-3.193 1.34-3.193 2.413 0 1.753 3.02 2.667 6 2.667s6-.914 6-2.667c0-1.073-1.167-1.947-3.193-2.387"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })